import { track } from '../facade';
import debounce from 'lodash/throttle';

const dispatch = (productId, time) =>
  track('magnifier', {
    category: productId,
    label: `dragged for ${time} seconds`,
  });

export const trackMagnifierDragged = debounce((productId, time) => dispatch(productId, time), 500);



// WEBPACK FOOTER //
// ./src/client/js/analytics/category/magnifier.js